import PatheIndex from './pathe';
import ScrollMagic from "scrollmagic";

export default class PatheIndexDesktop extends PatheIndex {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {
        this.dom.containerPresidentWord = this.dom.page.querySelector('.js-container-president-word');
        if( this.dom.containerPresidentWord ) {
            this.dom.animatePresidentWord = {
                image : this.dom.containerPresidentWord.querySelector('.js-img-container'),
                mask : this.dom.containerPresidentWord.querySelector('.js-anim-mask'),
            };
        }

        this.dom.containerSlider = this.dom.page.querySelector('.js-pathe-slider');
        if( this.dom.containerSlider ) {
            this.dom.animateSlider = {
                titles : this.dom.containerSlider.querySelectorAll('.js-slider-title'),
                slider : this.dom.containerSlider.querySelector('.js-slider-wrapper'),
                text : this.dom.containerSlider.querySelector('.js-text-wrapper'),
            };
        }

        this.dom.containerPatheActivities = this.dom.page.querySelector('.js-pathe-activities');
        if( this.dom.containerPatheActivities ) {
            this.dom.animatePatheActivities = {
                title : this.dom.containerPatheActivities.querySelector('.js-activities-title'),
                list : this.dom.containerPatheActivities.querySelector('.js-activities-list'),
            };
        }

    }

    init() {
        super.init();

        this._initScrollAnim();
    }

    _initScrollAnim() {
        if( this.dom.containerPresidentWord ) {

            if( this.dom.containerPresidentWord  )
                this._animPresidentWord();

            if( this.dom.containerSlider  )
                this._animSlider();

            if( this.dom.containerPatheActivities  )
                this._animPatheActivities();
        }
    }

    _animPresidentWord() {

        /** BACKGROUND **/

        // Create Tweenmax Animation
        let tweenImage = new TimelineMax();
        tweenImage
            .fromTo( this.dom.animatePresidentWord.image, 5, {y: 300}, { y: 0, ease: Power1.easeOut })

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.containerPresidentWord,
            offset: -window.innerHeight / 2,
            duration: this.dom.containerPresidentWord.offsetHeight
        });
        scene.setTween( tweenImage );
        scene.addTo(this._scrollMagicController);
        this._scrollMagicScenes.push( scene );


        /** MASK TEXT **/
        let tweenContent = new TimelineMax();
        tweenContent
            .fromTo( this.dom.animatePresidentWord.mask, 5, {x: 0}, { x: '100%', ease: Power1.easeOut })

        // Plug the tween to ScrollMagic Scene
        scene = new ScrollMagic.Scene({
            triggerElement: this.dom.containerPresidentWord,
            // offset: -window.innerHeight / 4,
            triggerHook: 0.60,
            duration: 400
        });
        scene.setTween( tweenContent );
        scene.addTo(this._scrollMagicController);
        this._scrollMagicScenes.push( scene );
    }

    _animSlider() {

        // Create Tweenmax Animation
        let tweenContent = new TimelineMax();
        if( this.dom.animateSlider.titles.length > 0 )
            tweenContent
                .fromTo( this.dom.animateSlider.titles, 5, { y: 300 }, { y: 0, ease: Power4.easeOut }, 'init' )
        tweenContent
            .fromTo( this.dom.animateSlider.slider, 5, { y: 300 }, { y: 0 , ease: Power4.easeOut }, 'init+=1')
            .fromTo( this.dom.animateSlider.text, 5, { y: 300 }, { y: 0 , ease: Power4.easeOut }, 'init+=1')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.containerSlider,
            offset: -window.innerHeight / 2,
            duration: this.dom.containerSlider.offsetHeight
        });
        scene.setTween( tweenContent );
        scene.addTo(this._scrollMagicController);
        this._scrollMagicScenes.push( scene );
    }

    _animPatheActivities() {

        // Create Tweenmax Animation
        let tweenContent = new TimelineMax();
        if( this.dom.animatePatheActivities.title )
            tweenContent
                .fromTo( this.dom.animatePatheActivities.title, 5, { y: 300 }, { y: 0, ease: Power4.easeOut }, 'init' )

        if( this.dom.animatePatheActivities.list )
            tweenContent
                .fromTo( this.dom.animatePatheActivities.list, 5, { y: 300 }, { y: 0 , ease: Power4.easeOut }, 'init+=1')

        // Plug the tween to ScrollMagic Scene
        let scene = new ScrollMagic.Scene({
            triggerElement: this.dom.containerPatheActivities,
            offset: -window.innerHeight / 2,
            duration: this.dom.containerPatheActivities.offsetHeight
        });
        scene.setTween( tweenContent );
        scene.addTo(this._scrollMagicController);
        this._scrollMagicScenes.push( scene );
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/pathe/pathe.desktop.js